import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zaosheng",
  "use": "icon-zaosheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zaosheng\"><defs><style type=\"text/css\"></style></defs><path d=\"M460.8 51.2h102.4v921.6H460.8zM921.6 358.4h102.4v307.2h-102.4zM0 358.4h102.4v307.2H0zM716.8 204.8h102.4v614.4h-102.4zM204.8 204.8h102.4v614.4H204.8z\" p-id=\"2806\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol